import axios from 'axios';
import { PublicCompanyItem } from './publicCompanyService';

export interface AdminCompanyPreviewItem extends PublicCompanyItem {
  isPublished: boolean;
}

export interface AdminCompaniesPreviewResponse {
  success: true;
  data: {
    companies: AdminCompanyPreviewItem[];
    total: number;
  };
}

const apiClient = axios.create({
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

export const adminPublicCompanyService = {
  /**
   * 学生向け企業一覧の管理者プレビューを取得する。
   * includeUnpublished=true で非公開（isPublished=false）の企業も含める。
   */
  async getPreview(
    includeUnpublished: boolean,
    limit?: number
  ): Promise<AdminCompaniesPreviewResponse> {
    const params = new URLSearchParams();
    if (includeUnpublished) params.set('includeUnpublished', 'true');
    if (typeof limit === 'number' && Number.isFinite(limit) && limit > 0) {
      params.set('limit', String(limit));
    }
    const qs = params.toString();
    const url = `/api/admin/companies/public-preview${qs ? `?${qs}` : ''}`;
    const response = await apiClient.get<AdminCompaniesPreviewResponse>(url);
    return response.data;
  },
};
